import { createContext, useContext, useLayoutEffect, useState } from 'react';
import './controls.css';
const STORAGE_KEY = 'liminality-appearance';
const valid = value => ['light', 'dark', 'system'].includes(value) ? value : 'system';
function readPreference() { try { return valid(localStorage.getItem(STORAGE_KEY)); } catch { return 'system'; } }
const AppearanceContext = createContext(null);
export function AppearanceProvider({ enabled = true, children }) {
  const [preference, setPreference] = useState(readPreference);
  useLayoutEffect(() => {
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    function apply() {
      const dark = enabled && (preference === 'dark' || (preference === 'system' && media?.matches));
      document.documentElement.dataset.theme = dark ? 'dark' : 'light';
      document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) meta.content = dark ? '#191917' : '#f5f4ef';
    }
    apply();
    media?.addEventListener?.('change', apply);
    function sync(event) { if (event.key === STORAGE_KEY || event.key === null) setPreference(readPreference()); }
    window.addEventListener('storage', sync);
    return () => { media?.removeEventListener?.('change', apply); window.removeEventListener('storage', sync); };
  }, [preference, enabled]);
  function choose(value) {
    setPreference(valid(value));
    try { localStorage.setItem(STORAGE_KEY, valid(value)); } catch { /* The choice still works for this visit. */ }
  }
  return <AppearanceContext.Provider value={{preference, choose}}>{children}</AppearanceContext.Provider>;
}
export function AppearanceControl({ language = 'en' }) {
  const appearance = useContext(AppearanceContext);
  if (!appearance) return null;
  const italian = language === 'it';
  return <label className="appearance-control"><span>{italian ? 'Aspetto' : 'Appearance'}</span><select value={appearance.preference} onChange={event => appearance.choose(event.target.value)}>
    <option value="system">{italian ? 'Sistema' : 'System'}</option><option value="light">{italian ? 'Chiaro' : 'Light'}</option><option value="dark">{italian ? 'Scuro' : 'Dark'}</option>
  </select></label>;
}
